import React from 'react'
import TitleContentBox from '../sections/title-content-box'

const TitleContentBoxSlice = ({ slice }) => {
  const {
    title_content_box_title,
    title_content_box_title_position,
    title_content_box_content,
    title_content_box_margin_bottom,
    title_content_box_container_fluid,
    title_content_box_text_color,
    title_content_box_background_color,
  } = slice.primary

  return (
    <TitleContentBox
      title={ title_content_box_title.text }
      titlePosition={ title_content_box_title_position }
      content={ title_content_box_content.text && title_content_box_content.html }
      marginBottom={ title_content_box_margin_bottom }
      containerFluid={ title_content_box_container_fluid }
      textColor={ title_content_box_text_color }
      backgroundColor={ title_content_box_background_color }
    />
  )
}

export default TitleContentBoxSlice